// internal
import { axios, def, handleResponse, handleError } from './internal';

// client-shared
import { storage } from '@goldblack/client-storage';

function AdminObjectUpdate(service, type, data) {
    storage.transience.setState(`${service}.${type}.loading`, true);

    axios
        .post('/api/admin_object_update', {
            service,
            type,
            data,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const result = res.data.data;
                    const callback = (item) => item._id === result._id;
                    storage.transience.updateState(`${service}.${type}.data`, callback, result);

                    storage.transience.setState('internal.success', 'The item has been updated.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            storage.transience.setState(`${service}.${type}.loading`, false);
        });
}

function AdminConfigUpdate(service, action, type, key, changes, onSuccess) {
    axios
        .post('/api/admin_config_update', { service, action, type, key, changes })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const { client, server, clientMeta, serverMeta } = res.data.data;
                    storage.transience.setState(`${service}.client.data`, client);
                    storage.transience.setState(`${service}.server.data`, server);
                    if (clientMeta) storage.transience.setState(`${service}.client.meta`, clientMeta);
                    if (serverMeta) storage.transience.setState(`${service}.server.meta`, serverMeta);
                    storage.transience.setState('internal.success', 'Config updated successfully.');
                    if (onSuccess) onSuccess();
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminObjectUpdate, AdminConfigUpdate };
